// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s1-c";
export var backButton = "_s1-4";
export var backIcon = "_s1-5";
export var chevronShortcut = "_s1-6";
export var container = "_s1-1";
export var editor = "_s1-8";
export var editorWrapper = "_s1-7";
export var prefix = "_s1-2";
export var searchIcon = "_s1-3";
export var suffix = "_s1-9";
export var suffixContent = "_s1-a";
export var suffixText = "_s1-b";
export var wrapper = "_s1-0";